import React, { useEffect, useState } from 'react';

import { fetchAllReservationsReport, fetchAllReservationsReportDownload, fetchAllReservationsReportView } from 'actions/allReservations';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import useUserAccount from 'hooks/useUserAccount';
import { CostCenter } from 'models/costCenter';
import { getCostCenters } from 'services/costCenterService';
import { AllReservationsReportRequest, AllReservationsReportResponse } from 'models/allReservationsReport';
import AllReservationsReport from 'screens/components/AllReservationsReport';
import { Company } from 'models/company';
import { getAllBranchesCompanies } from 'services/companyService';
import { extractErrorMessage } from 'utils/generic';
import { BreakRulesReason } from 'services/travelBreakRulesReasonService';
import { Group } from 'models/group';
import { TravelStatus } from 'models/travelStatus';
import { AdminUser } from 'models/adminUser';

const AllReservationsReportContainer = () => {
  const [costCenterList, setCostCenterList] = useState<CostCenter[]>([]);
  const [breakRuleReasonIdList, setBreakRuleReasonIdList] = useState<BreakRulesReason[]>([]);
  const [userGroupIdList, setUserGroupIdList] = useState<Group[]>([]);
  const [travelStatusList, setTravelStatusList] = useState<TravelStatus[]>([]);
  const [allCompaniesList, setAllCompaniesList] = useState<Company[]>([]);
  const [allUsersList, setAllUsersList] = useState<AdminUser[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isReportDownloadLoading, setIsReportDownloadLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const [report, setReport] = useState<AllReservationsReportResponse>();
  const userAccount = useUserAccount();

  const handleFetchAllReservationsReport = async (filters: AllReservationsReportRequest, type: string) => {
    console.log('handleFetchAllReservationsReport');
    if (type === 'email') {
      handleEmailReport(filters);
    }

    if (type === 'screen') {
      handleReportOnScreen(filters);
    }

    if (type === 'download') {
      handleDownloadReport(filters);
    }
  };

  const handleReportOnScreen = async (filters: AllReservationsReportRequest) => {
    setIsSubmitting(true);
    try {
      const {
        data: { data },
      } = await fetchAllReservationsReportView(filters);

      setReport(data);

      setIsSubmitting(false);
    } catch (e) {
      setIsSubmitting(false);
      throw e;
    }
  };

  const handleEmailReport = async (filters: AllReservationsReportRequest) => {
    setIsSubmitting(true);
    try {
        fetchAllReservationsReport(filters);

      toast.add({ type: 'success', message: t('costCenter.report.filterForm.success') });
      setIsSubmitting(false);
    } catch (e) {
      setIsSubmitting(false);
      throw e;
    }
  };

  const handleDownloadlReport = async (filters: AllReservationsReportRequest) => {
    setIsSubmitting(true);
    try {
      fetchAllReservationsReportDownload(filters);

      toast.add({ type: 'success', message: t('costCenter.report.filterForm.success') });
      setIsSubmitting(false);
    } catch (e) {
      setIsSubmitting(false);
      throw e;
    }
  };

  const handleDownloadReport = async (filters: AllReservationsReportRequest) => {
    try {
      setIsReportDownloadLoading(true);
      const data = await fetchAllReservationsReportDownload(filters);
      handleDownloadReportFile(data);
      toast.add({ type: 'success', message: t('expensesList.downloadReportSuccess') });
    } catch (error) {
      toast.add({ type: 'danger', message: extractErrorMessage(error) });
    } finally {
      setIsReportDownloadLoading(false);
    }
  };

  const handleDownloadReportFile = (data) => {
    const blob = new Blob([data.data], { type: 'application/zip' });
    const fileName = 'AllTravels_TravelCorporate.zip';

    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const handleFetchUsersAndInvites = async () => {


  };

  useEffect(() => {
    const getDataCostCenterList = async () => {
      try {
        setIsLoading(true);
        const res = await getCostCenters(userAccount.companyId);

        res.data.result.unshift({
          id: '00000000-0000-0000-0000-000000000000',
          code: '',
          name: t('costCenter.report.filterForm.products.all'),
        } as CostCenter);
        setCostCenterList(res.data.result);

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);

        toast.add({
          type: 'danger',
          message: t('costCenter.report.filterForm.error'),
        });
      }
    };

    const getDataAllCompaniesList = async () => {
      try {
        setIsLoading(true);
        const res = await getAllBranchesCompanies(userAccount.companyId);
        setAllCompaniesList(res);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);

        toast.add({
          type: 'danger',
          message: t('costCenter.report.filterForm.error'),
        });
      }
    };

    getDataAllCompaniesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    getDataCostCenterList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <AllReservationsReport
      allReservationsList={null}
      allCompaniesList={allCompaniesList}
      allUsersList={allUsersList}
      allCostCenterList={costCenterList}
      allBreakRuleReasonIdList={breakRuleReasonIdList}
      allUserGroupIdList={userGroupIdList}
      fetchReportSummary={handleFetchAllReservationsReport}
      fetchUsersAndInvites={handleFetchUsersAndInvites}
      isLoading={isLoading}
      isSubmit={isSubmitting}
      report={report}
    />
  );
};

export default AllReservationsReportContainer;
